module.exports = __webpack_public_path__ + "img/granada_hero_card.9b1f60c0.png";